import {
  Activity,
  ArrowLeftRight,
  Banknote,
  BarChart3,
  Bell,
  BookOpen,
  Boxes,
  Building2,
  CircleDollarSign,
  ClipboardList,
  Coins,
  CreditCard,
  FileText,
  FolderOpen,
  Glasses,
  Globe,
  Home,
  Landmark,
  LayoutDashboard,
  MapPin,
  Package,
  Percent,
  Printer,
  Receipt,
  RotateCcw,
  Scale,
  ScrollText,
  Settings,
  Shield,
  ShoppingCart,
  Store,
  Tag,
  Trash2,
  TrendingUp,
  Truck,
  Undo2,
  User,
  Users,
  Wallet,
} from "lucide-react";

/** Nav labelKey → Lucide icon component. */
export const MENU_ICONS = {
  "nav.operations": Activity,
  "nav.pointOfSale": ShoppingCart,
  "nav.heldBills": ClipboardList,
  "nav.online": Globe,
  "nav.onlineOrders": Package,
  "nav.onlineHistory": FolderOpen,
  "nav.masters": BookOpen,
  "nav.categories": Tag,
  "nav.products": Boxes,
  "nav.brands": Tag,
  "nav.shelves": LayoutDashboard,
  "nav.areas": MapPin,
  "nav.units": Scale,
  "nav.customers": Users,
  "nav.suppliers": Truck,
  "nav.promotions": Percent,
  "nav.promotionRules": CreditCard,
  "nav.priceChanges": CircleDollarSign,
  "nav.barcodeLabels": Printer,
  "nav.privilegeCards": CreditCard,
  "nav.inventory": Package,
  "nav.inventoryHub": Home,
  "nav.stockSummary": BarChart3,
  "nav.batches": ScrollText,
  "nav.imei": Glasses,
  "nav.purchaseRequests": ClipboardList,
  "nav.purchaseOrders": FileText,
  "nav.grn": Receipt,
  "nav.purchaseDebitNotes": FileText,
  "nav.transfers": ArrowLeftRight,
  "nav.adjustments": Scale,
  "nav.wrapping": Package,
  "nav.wastage": Trash2,
  "nav.supplierReturns": Undo2,
  "nav.inventoryAlerts": Bell,
  "nav.accounts": Wallet,
  "nav.schedules": ScrollText,
  "nav.accountsChart": BookOpen,
  "nav.receiptVoucher": Banknote,
  "nav.paymentVoucher": Coins,
  "nav.journalVoucher": BookOpen,
  "nav.contraVoucher": RotateCcw,
  "nav.debitNote": TrendingUp,
  "nav.creditNote": TrendingUp,
  "nav.ledgerReport": FileText,
  "nav.trialBalance": Scale,
  "nav.profitLoss": TrendingUp,
  "nav.balanceSheet": Landmark,
  "nav.cashBook": Banknote,
  "nav.bankBook": Building2,
  "nav.dayBook": ScrollText,
  "nav.reports": FileText,
  "nav.reportCenter": BarChart3,
  "nav.misReports": LayoutDashboard,
  "nav.administration": Settings,
  "nav.users": User,
  "nav.roles": Shield,
  "nav.auditLog": ScrollText,
  "nav.counters": LayoutDashboard,
  "nav.loyalty": CreditCard,
  "nav.denominations": Coins,
  "nav.weighingMachines": Scale,
  "nav.printers": Printer,
  "nav.companySetup": Building2,
  "nav.storeSetup": Store,
  "nav.taxSettings": Receipt,
  "nav.generalSettings": Settings,
  "nav.onlineStore": Store,
  "nav.dashboard": LayoutDashboard,
  "nav.invoiceHistory": ScrollText,
  "nav.quotations": FileText,
  "nav.salesReturns": Undo2,
  "nav.openingPhysical": Boxes,
  "nav.accountingSettings": Settings,
};

const CAT_ICON_MAP = {
  Frames: Glasses,
  Lenses: Glasses,
  Contacts: Glasses,
  Accessories: Package,
  Services: Settings,
  Default: Glasses,
};

export function getMenuIcon(labelKey, size = 16, className = "shrink-0 opacity-80") {
  const Icon = MENU_ICONS[labelKey] || LayoutDashboard;
  return <Icon size={size} className={className} aria-hidden />;
}

export function getCatIcon(name, size = 18, className = "") {
  if (!name) {
    return <Glasses size={size} className={className} aria-hidden />;
  }
  const key = Object.keys(CAT_ICON_MAP).find((k) => name.toLowerCase().includes(k.toLowerCase()));
  const Icon = key ? CAT_ICON_MAP[key] : CAT_ICON_MAP.Default;
  return <Icon size={size} className={className} aria-hidden />;
}

export const HUB_ICONS = {
  stock: BarChart3,
  alerts: Bell,
  requests: ClipboardList,
  grn: Receipt,
  orders: FileText,
  returns: Undo2,
  transfers: ArrowLeftRight,
  adjustments: Scale,
  wastage: Trash2,
  opening: Boxes,
};

export function getHubIcon(key, size = 22, className = "") {
  const Icon = HUB_ICONS[key] || Package;
  return <Icon size={size} className={className} aria-hidden />;
}
